
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.95 0L9.9 4.95 8.484 6.364 5.95 3.828V13h-2V3.828L1.414 6.364 0 4.95 4.95 0zm8 18l4.95-4.95-1.415-1.414-2.535 2.536V5h-2v9.172l-2.536-2.536L8 13.05 12.95 18z"}})])
          )
        }
      }
    